module.exports = __webpack_public_path__ + "static/img/code.95c6385.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/code.jpg
// module id = xnyY
// module chunks = 1